customElements.get('product-card-2022') ||
    customElements.define('product-card-2022', class extends HTMLElement {
        get title() {
            return this.getAttribute('title');
        }
        get id() {
            return this.getAttribute('id');
        }
        get productId() {
            return this.getAttribute('productId');
        }
        get image() {
            return this.getAttribute('image');
        }
        get price() {
            return this.getAttribute('price');
        }
        get url() {
            return this.getAttribute('url');
        }
        get tags() {
            return this.getAttribute('tags');
        }
        get available() {
            return this.getAttribute('available');
        }
        static get observedAttributes() {
            return ['id', 'tags', 'title', 'image', 'price', 'url', 'available'];
        }
        constructor() {
            super();
            this.div = document.createElement('div');
            this.div.className = 'tailwind';
            // Wait for DOM to be ready before trying to access template
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => this.initializeTemplate());
            }
            else {
                this.initializeTemplate();
            }
        }
        initializeTemplate() {
            let template = document.getElementById('product-card-2022-template');
            if (!template) {
                console.error('product-card-2022-template not found in DOM');
                return;
            }
            let templateContent = template.content;
            let elementContent = templateContent.cloneNode(true);
            this.div.append(elementContent);
            this.render();
        }
        connectedCallback() {
            this.render();
        }
        attributeChangedCallback(prop, oldVal, newVal) {
            this.render();
        }
        render() {
            // Check if template is loaded
            if (!this.div.children || this.div.children.length === 0) {
                console.warn('ProductCard2022 template not loaded yet, skipping render');
                return;
            }
            const container = window.document.querySelectorAll(`product-card-2022[id="${this.id}"]`);
            if (container.length > 0) {
                container[0].innerHTML = '';
            }
            const productCard = this.div.querySelectorAll('.product-card-2022')[0];
            if (!productCard) {
                console.error('Product card element not found in template');
                return;
            }
            productCard.id = this.id;
            let separator = '.jpg';
            if (this.image.indexOf(separator) === -1) {
                separator = '.png';
            }
            const imageURL = this.image.split(separator);
            // @ts-ignore
            productCard.querySelectorAll('#product-card-2022-image')[0].src =
                imageURL[0] + '_x400' + separator + imageURL[1];
            const titleSplitted = this.title.split('-');
            productCard.querySelectorAll('#product-card-2022-title1')[0].innerHTML =
                titleSplitted[0].trim().slice(0, 35);
            if (titleSplitted.length > 1) {
                productCard.querySelectorAll('#product-card-2022-title2')[0].innerHTML =
                    titleSplitted[1].trim();
            }
            productCard.querySelectorAll('#product-card-2022-price')[0].innerHTML =
                '$' + this.price;
            productCard.querySelectorAll('#product-card-2022-ratings')[0].dataset.bvProductId = this.productId;
            productCard.querySelectorAll('#product-card-2022-ratings')[0].dataset.bvRedirectUrl = this.url;
            productCard
                .querySelectorAll('#product-card-2022-new-label')[0]
                .classList.add('hidden');
            productCard
                .querySelectorAll('#product-card-2022-onsale-label')[0]
                .classList.add('hidden');
            productCard
                .querySelectorAll('#product-card-2022-seasonal-label')[0]
                .classList.add('hidden');
            productCard
                .querySelectorAll('#product-card-2022-bestseller-label')[0]
                .classList.add('hidden');
            if (!!this.tags) {
                if (this.tags.toLowerCase().indexOf('bestseller') > -1) {
                    productCard
                        .querySelectorAll('#product-card-2022-bestseller-label')[0]
                        .classList.remove('hidden');
                }
                else if (this.tags.toLowerCase().indexOf('onsale') > -1 || this.tags.toLowerCase().indexOf('onslae') > -1 || this.tags.toLowerCase().indexOf('sale') > -1) {
                    const onsaleLabel = productCard
                        .querySelectorAll('#product-card-2022-onsale-label')[0];
                    onsaleLabel.classList.remove('hidden');
                    onsaleLabel.style.color = '#FFF';
                }
                else if (this.tags.toLowerCase().indexOf('seasonal') > -1 || this.tags.toLowerCase().indexOf('limited time') > -1) {
                    const seasonalLabel = productCard
                        .querySelectorAll('#product-card-2022-seasonal-label')[0];
                    seasonalLabel.classList.remove('hidden');
                    seasonalLabel.style.color = '#FFF';
                }
                else if (this.tags.toLowerCase().indexOf('new') > -1) {
                    const newLabel = productCard
                        .querySelectorAll('#product-card-2022-new-label')[0];
                    newLabel.classList.remove('hidden');
                    newLabel.style.color = '#FFF';
                }
            }
            const ctaLabel = productCard.querySelector('.cta-label');
            const ctaLink = productCard.querySelector('a.cta-link') || productCard.closest('a');
            if (!ctaLabel) {
                console.error('CTA label element not found in template');
                return;
            }
            ctaLabel.classList.remove('cta-default');
            ctaLabel.classList.add('cta-disabled');
            ctaLabel.innerHTML = 'Sold Out';
            if (ctaLink) {
                ctaLink.removeAttribute('href');
            }
            if (this.available === 'true') {
                if (ctaLink) {
                    ctaLink.href = this.url;
                }
                ctaLabel.classList.remove('cta-disabled');
                ctaLabel.classList.add('cta-default');
                // Searchanise renders results through this component, so the Liquid
                // CTA rules in snippets/product-card-2022.liquid never run here.
                // Search uses the snippet's default label; the metafield-driven
                // rules stay in Liquid and continue to drive every other surface.
                ctaLabel.innerHTML = 'View Product';
            }
            if (container.length > 0) {
                container[0].append(this.div);
            }
        }
    });
